/*
 * TerriSTORY®
 *
 © Copyright 2022 AURA-EE
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * A copy of the GNU Affero General Public License should be present along
 * with this program at the root of current repository. If not, see
 * http://www.gnu.org/licenses/.
 */

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Api from "../../Controllers/Api";
import config from "../../settings.js";
import { buildRegionUrl, exportToCSV } from "../../utils.js";

/**
 * This admin page manages PCAET data and updates them from ADEME's files.
 */
function Pcaet(_ref) {
  let {
    connected,
    userInfos,
    parentApi
  } = _ref;
  if (!connected || !userInfos || userInfos.profil !== "admin") {
    return /*#__PURE__*/React.createElement("div", null, "Non accessible.");
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", null, "Gestion des PCAET"), /*#__PURE__*/React.createElement("div", {
    className: "block-etape",
    style: {
      marginBottom: "32px"
    }
  }, /*#__PURE__*/React.createElement("h4", null, "R\xE9cup\xE9ration des PCAET"), /*#__PURE__*/React.createElement(UpdatePcaetFromAdeme, {
    region: parentApi.data.region
  })), /*#__PURE__*/React.createElement(UpdateSirenAssignment, {
    region: parentApi.data.region
  }), /*#__PURE__*/React.createElement("div", {
    className: "block-etape"
  }, /*#__PURE__*/React.createElement("h4", null, "Liste des PCAET"), /*#__PURE__*/React.createElement(Link, {
    to: "/agregation_pcaet",
    onClick: () => parentApi.callbacks.updateZoneType({
      zone: "region",
      maille: "epci"
    }, parentApi.data.regionCode)
  }, "C\u2019est par ici !")));
}
function UpdatePcaetFromAdeme(_ref2) {
  let {
    region,
    onSuccess
  } = _ref2;
  const [pcaetUpdateMessage, setPcaetUpdateMessage] = useState("");
  const loadingMessage = "Mise à jour en cours... ceci peut prendre quelques minutes";
  const errorMessage = "Erreur lors du chargement de données. Réessayez ultérieurement.\nSi l'erreur persiste, contactez AURA-EE.";

  /** Call the API to update PCAET data from ADEME */
  function run_update_pcaet() {
    setPcaetUpdateMessage(loadingMessage);
    let url = buildRegionUrl(config.mise_a_jour_des_pcaet_ademe, region);
    Api.callApi(url).then(() => {
      setPcaetUpdateMessage("Mise à jour réussie !");
      if (onSuccess) onSuccess();
    }).catch(e => {
      console.error(e);
      setPcaetUpdateMessage(errorMessage);
      alert(errorMessage);
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary",
    disabled: pcaetUpdateMessage === loadingMessage,
    onClick: () => run_update_pcaet()
  }, "Mettre \xE0 jour les PCAET"), pcaetUpdateMessage && /*#__PURE__*/React.createElement("p", null, pcaetUpdateMessage));
}
function UpdateSirenAssignment(_ref3) {
  let {
    region,
    onSuccess
  } = _ref3;
  const [sirenData, setSirenData] = useState([]);
  const [updateSwitch, forceUpdate] = useState(false);
  useEffect(() => {
    const url = buildRegionUrl(config.api_siren_assignment, region);
    Api.callApi(url).then(setSirenData);
  }, [region, updateSwitch]);
  const updateSirenAssignment = e => {
    e.preventDefault();
    const file = e.target.elements.file.files[0];
    let formData = new FormData();
    formData.append("fichier", file);
    const url = buildRegionUrl(config.api_siren_assignment, region);
    Api.callApi(url, formData, "PUT", "default").then(() => {
      forceUpdate(!updateSwitch);
      if (onSuccess) onSuccess();
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "block-etape"
  }, /*#__PURE__*/React.createElement("h4", null, "Voir ou modifier les num\xE9ro de SIREN"), /*#__PURE__*/React.createElement("table", {
    className: "table_preview_header",
    style: {
      margin: "auto"
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "zone_type", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("i", null, "(\xC9chelle territoriale)")), /*#__PURE__*/React.createElement("th", null, "zone_id", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("i", null, "(Num\xE9ro du territoire)")), /*#__PURE__*/React.createElement("th", null, "siren", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("i", null, "(Num\xE9ro de SIREN)")), /*#__PURE__*/React.createElement("th", null, "epcis", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("i", null, "(Liste des num\xE9ros d'EPCI composant le territoire)"))), sirenData.length ? sirenData.map(row => /*#__PURE__*/React.createElement("tr", {
    key: row.zone_id
  }, /*#__PURE__*/React.createElement("td", null, row.zone_type), /*#__PURE__*/React.createElement("td", null, row.zone_id), /*#__PURE__*/React.createElement("td", null, row.siren), /*#__PURE__*/React.createElement("td", null, JSON.stringify(row.epcis)))) : /*#__PURE__*/React.createElement("tr", {
    style: {
      color: "grey"
    }
  }, /*#__PURE__*/React.createElement("td", {
    colSpan: 4
  }, "[Table vide]")))), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-info",
    onClick: () => exportToCSV(sirenData, "csv"),
    style: {
      margin: "4px"
    }
  }, "Exporter en CSV"), /*#__PURE__*/React.createElement("form", {
    onSubmit: updateSirenAssignment
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    name: "file",
    required: true
  }), /*#__PURE__*/React.createElement("input", {
    className: "btn btn-success",
    type: "submit",
    value: "Mettre \xE0 jour"
  })), /*#__PURE__*/React.createElement("br", null));
}
export default Pcaet;